// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.letterhead-letterhead-container {
  padding: 20px;
  text-align: center;
  font-family: 'Helvetica', Arial, sans-serif;
  background-color: #f4f4f4;
  min-height: 100vh;
}

.letterhead-open-popup-btn {
  padding: 12px 24px;
  background-color: #00468C;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.letterhead-open-popup-btn:hover {
  background-color: #003366;
}

.letterhead-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.letterhead-popup-content {
  background-color: #f5f5f5;
  width: 60%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  font-family: 'Helvetica', Arial, sans-serif;
}

@media (max-width: 768px) {
  .letterhead-popup-content {
    width: 90%;
    padding: 20px;
  }
}

.letterhead-letterhead-header {
  position: relative;
  text-align: center;
  margin-bottom: 20px;
}

.letterhead-watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.1;
  width: 40%;
  height: auto;
  z-index: -1;
  object-fit: contain;
}

.letterhead-letterhead-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: #00468C;
}

.letterhead-letterhead-tagline {
  font-size: 14px;
  font-style: italic;
  color: #555;
  margin: 8px 0;
}

.letterhead-letterhead-subtitle {
  font-size: 12px;
  color: #666;
  margin: 10px 0;
}

.letterhead-letterhead-subtitle a {
  color: #00468C;
  text-decoration: none;
}

.letterhead-letterhead-subtitle a:hover {
  text-decoration: underline;
}

.letterhead-letter-form {
  margin-top: 20px;
}

.letterhead-form-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.letterhead-form-group {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}

.letterhead-input-container {
  flex: 1 1;
  position: relative;
}

.letterhead-form-group label {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  text-align: left;
  width: 150px;
  flex-shrink: 0;
  padding-top: 8px;
}

.letterhead-letter-type-select,
.letterhead-input-field {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  font-family: 'Helvetica', Arial, sans-serif;
  background-color: #fff;
  transition: border-color 0.3s;
}

.letterhead-letter-type-select:focus,
.letterhead-input-field:focus {
  border-color: #00468C;
  outline: none;
}

.letterhead-highlighted-select {
  background-color: #e6f3ff;
}

.letterhead-content-area {
  font-family: 'Helvetica', Arial, sans-serif;
  font-size: 11pt;
  line-height: 14pt;
  width: 100%;
  min-height: 200px;
  border: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 4px;
  resize: vertical;
  background-color: #fff;
}

.letterhead-content-area h1 {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
}

.letterhead-content-area h2 {
  font-size: 16px;
  font-weight: bold;
  margin: 8px 0;
}

.letterhead-content-area p {
  margin: 8px 0;
  line-height: 1.6;
}

.letterhead-content-area:focus {
  outline: none;
  border-color: #00468C;
  box-shadow: 0 0 5px rgba(0, 70, 140, 0.3);
}

.letterhead-content-area[contenteditable]:empty:before {
  content: 'Enter your content here...';
  color: #999;
}

.letterhead-formatting-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.letterhead-format-btn {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f5f5f5;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
}

.letterhead-format-btn:hover {
  background-color: #e0e0e0;
}

.letterhead-popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.letterhead-cancel-btn,
.letterhead-preview-btn,
.letterhead-save-btn,
.letterhead-close-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.letterhead-cancel-btn {
  background-color: #6c757d;
  color: white;
}

.letterhead-cancel-btn:hover {
  background-color: #5a6268;
}

.letterhead-preview-btn {
  background-color: #007bff;
  color: white;
}

.letterhead-preview-btn:hover {
  background-color: #0056b3;
}

.letterhead-save-btn {
  background-color: #007bff;
  color: white;
}

.letterhead-save-btn:hover {
  background-color: #0056b3;
}

.letterhead-close-btn {
  background-color: #dc3545;
  color: white;
}

.letterhead-close-btn:hover {
  background-color: #c82333;
}

.letterhead-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.letterhead-preview-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

@media print {
  .letterhead-popup-overlay,
  .letterhead-open-popup-btn,
  .letterhead-letter-type-select,
  .letterhead-formatting-buttons,
  .letterhead-popup-actions {
    display: none;
  }

  .letterhead-popup-content {
    width: 100%;
    height: auto;
    box-shadow: none;
    border: none;
    padding: 0;
    margin: 0;
    overflow: visible;
  }

  .letterhead-letterhead-header,
  .letterhead-letter-form {
    margin: 0;
    padding: 20px;
  }

  .letterhead-input-field,
  .letterhead-content-area {
    border: none;
    background: transparent;
    width: 100%;
    padding: 0;
    font-family: 'Helvetica', Arial, sans-serif;
    line-height: 1.6;
  }

  .letterhead-content-area {
    white-space: pre-wrap;
  }

  .letterhead-watermark {
    opacity: 0.05;
    width: 40%;
  }

  .letterhead-form-group label {
    display: none;
  }
}

@media (max-width: 768px) {
  .letterhead-form-row {
    flex-direction: column;
  }

  .letterhead-form-group {
    flex-direction: column;
    align-items: flex-start;
  }

  .letterhead-form-group label {
    width: 100%;
    margin-bottom: 5px;
  }

  .letterhead-input-container {
    width: 100%;
  }

  .letterhead-formatting-buttons {
    margin-bottom: 10px;
  }
}

.letterhead-table-container {
  margin-top: 20px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.letterhead-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.letterhead-table th,
.letterhead-table td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.letterhead-table th {
  background-color: #00468C;
  color: white;
}

.letterhead-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.letterhead-table tr:hover {
  background-color: #ddd;
}

.letterhead-table a {
  color: #00468C;
  text-decoration: none;
}

.letterhead-table a:hover {
  text-decoration: underline;
}

.letterhead-download-link {
  color: #00468C;
  text-decoration: none;
}

.letterhead-download-link:hover {
  text-decoration: underline;
}

.letterhead-edit-icon {
  font-size: 1rem;
  cursor: pointer;
  color: #00468C;
  transition: color 0.2s;
}

.letterhead-edit-icon:hover {
  color: #003366;
}
`, "",{"version":3,"sources":["webpack://./src/components/letterHead/letterhead.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,2CAA2C;EAC3C,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE;;;;;IAKE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;EACnB;;EAEA;;IAEE,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,2CAA2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".letterhead-letterhead-container {\n  padding: 20px;\n  text-align: center;\n  font-family: 'Helvetica', Arial, sans-serif;\n  background-color: #f4f4f4;\n  min-height: 100vh;\n}\n\n.letterhead-open-popup-btn {\n  padding: 12px 24px;\n  background-color: #00468C;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n\n.letterhead-open-popup-btn:hover {\n  background-color: #003366;\n}\n\n.letterhead-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.letterhead-popup-content {\n  background-color: #f5f5f5;\n  width: 60%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  font-family: 'Helvetica', Arial, sans-serif;\n}\n\n@media (max-width: 768px) {\n  .letterhead-popup-content {\n    width: 90%;\n    padding: 20px;\n  }\n}\n\n.letterhead-letterhead-header {\n  position: relative;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.letterhead-watermark {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0.1;\n  width: 40%;\n  height: auto;\n  z-index: -1;\n  object-fit: contain;\n}\n\n.letterhead-letterhead-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0;\n  color: #00468C;\n}\n\n.letterhead-letterhead-tagline {\n  font-size: 14px;\n  font-style: italic;\n  color: #555;\n  margin: 8px 0;\n}\n\n.letterhead-letterhead-subtitle {\n  font-size: 12px;\n  color: #666;\n  margin: 10px 0;\n}\n\n.letterhead-letterhead-subtitle a {\n  color: #00468C;\n  text-decoration: none;\n}\n\n.letterhead-letterhead-subtitle a:hover {\n  text-decoration: underline;\n}\n\n.letterhead-letter-form {\n  margin-top: 20px;\n}\n\n.letterhead-form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 15px;\n}\n\n.letterhead-form-group {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  gap: 10px;\n}\n\n.letterhead-input-container {\n  flex: 1;\n  position: relative;\n}\n\n.letterhead-form-group label {\n  font-size: 14px;\n  font-weight: bold;\n  color: #000000;\n  text-align: left;\n  width: 150px;\n  flex-shrink: 0;\n  padding-top: 8px;\n}\n\n.letterhead-letter-type-select,\n.letterhead-input-field {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Helvetica', Arial, sans-serif;\n  background-color: #fff;\n  transition: border-color 0.3s;\n}\n\n.letterhead-letter-type-select:focus,\n.letterhead-input-field:focus {\n  border-color: #00468C;\n  outline: none;\n}\n\n.letterhead-highlighted-select {\n  background-color: #e6f3ff;\n}\n\n.letterhead-content-area {\n  font-family: 'Helvetica', Arial, sans-serif;\n  font-size: 11pt;\n  line-height: 14pt;\n  width: 100%;\n  min-height: 200px;\n  border: 1px solid #ccc;\n  padding: 10px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  resize: vertical;\n  background-color: #fff;\n}\n\n.letterhead-content-area h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.letterhead-content-area h2 {\n  font-size: 16px;\n  font-weight: bold;\n  margin: 8px 0;\n}\n\n.letterhead-content-area p {\n  margin: 8px 0;\n  line-height: 1.6;\n}\n\n.letterhead-content-area:focus {\n  outline: none;\n  border-color: #00468C;\n  box-shadow: 0 0 5px rgba(0, 70, 140, 0.3);\n}\n\n.letterhead-content-area[contenteditable]:empty:before {\n  content: 'Enter your content here...';\n  color: #999;\n}\n\n.letterhead-formatting-buttons {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.letterhead-format-btn {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.letterhead-format-btn:hover {\n  background-color: #e0e0e0;\n}\n\n.letterhead-popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.letterhead-cancel-btn,\n.letterhead-preview-btn,\n.letterhead-save-btn,\n.letterhead-close-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.letterhead-cancel-btn {\n  background-color: #6c757d;\n  color: white;\n}\n\n.letterhead-cancel-btn:hover {\n  background-color: #5a6268;\n}\n\n.letterhead-preview-btn {\n  background-color: #007bff;\n  color: white;\n}\n\n.letterhead-preview-btn:hover {\n  background-color: #0056b3;\n}\n\n.letterhead-save-btn {\n  background-color: #007bff;\n  color: white;\n}\n\n.letterhead-save-btn:hover {\n  background-color: #0056b3;\n}\n\n.letterhead-close-btn {\n  background-color: #dc3545;\n  color: white;\n}\n\n.letterhead-close-btn:hover {\n  background-color: #c82333;\n}\n\n.letterhead-preview-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.letterhead-preview-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 800px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n@media print {\n  .letterhead-popup-overlay,\n  .letterhead-open-popup-btn,\n  .letterhead-letter-type-select,\n  .letterhead-formatting-buttons,\n  .letterhead-popup-actions {\n    display: none;\n  }\n\n  .letterhead-popup-content {\n    width: 100%;\n    height: auto;\n    box-shadow: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n  }\n\n  .letterhead-letterhead-header,\n  .letterhead-letter-form {\n    margin: 0;\n    padding: 20px;\n  }\n\n  .letterhead-input-field,\n  .letterhead-content-area {\n    border: none;\n    background: transparent;\n    width: 100%;\n    padding: 0;\n    font-family: 'Helvetica', Arial, sans-serif;\n    line-height: 1.6;\n  }\n\n  .letterhead-content-area {\n    white-space: pre-wrap;\n  }\n\n  .letterhead-watermark {\n    opacity: 0.05;\n    width: 40%;\n  }\n\n  .letterhead-form-group label {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .letterhead-form-row {\n    flex-direction: column;\n  }\n\n  .letterhead-form-group {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .letterhead-form-group label {\n    width: 100%;\n    margin-bottom: 5px;\n  }\n\n  .letterhead-input-container {\n    width: 100%;\n  }\n\n  .letterhead-formatting-buttons {\n    margin-bottom: 10px;\n  }\n}\n\n.letterhead-table-container {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n}\n\n.letterhead-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.letterhead-table th,\n.letterhead-table td {\n  padding: 10px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.letterhead-table th {\n  background-color: #00468C;\n  color: white;\n}\n\n.letterhead-table tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.letterhead-table tr:hover {\n  background-color: #ddd;\n}\n\n.letterhead-table a {\n  color: #00468C;\n  text-decoration: none;\n}\n\n.letterhead-table a:hover {\n  text-decoration: underline;\n}\n\n.letterhead-download-link {\n  color: #00468C;\n  text-decoration: none;\n}\n\n.letterhead-download-link:hover {\n  text-decoration: underline;\n}\n\n.letterhead-edit-icon {\n  font-size: 1rem;\n  cursor: pointer;\n  color: #00468C;\n  transition: color 0.2s;\n}\n\n.letterhead-edit-icon:hover {\n  color: #003366;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
